export default "__VITE_ASSET__DBQgOzlk__"